/* ==========================================================================
   Nobile – Optin Black Friday 2026 (sezioni nlp-bf-*)
   - Countdown e cambio fase (pre-lancio -> Black Friday attivo) per ogni sezione
   - Form (hero + chiusura) -> Klaviyo Client API (chiave PUBBLICA, nessun segreto)
   - Evento Shopify "nlp_optin_lead" per il tracking (Custom Pixel, da attivare)
   Nessun testo hardcoded: tutti i messaggi arrivano dalle impostazioni delle
   sezioni tramite <script type="application/json">.
   Lo script è incluso da ogni sezione: la guard lo fa girare una sola volta.
   ========================================================================== */
(function () {
  if (window.NLPBF) return;

  var STORAGE_KEY = 'nlpbf_optin_done';
  var state = { done: false, name: '' };
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && saved.done) { state.done = true; state.name = saved.name || ''; }
  } catch (e) {}

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function readJSON(el) {
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }
  function configOf(section) {
    if (!section.__nlpConfig) section.__nlpConfig = readJSON(section.querySelector('script[data-nlp-config]'));
    return section.__nlpConfig;
  }

  /* ---------------- Fasi e countdown ---------------- */
  function renderSection(section) {
    var cfg = configOf(section);
    var targetMs = new Date(cfg.target || '').getTime();
    var ms = isNaN(targetMs) ? 0 : Math.max(0, targetMs - Date.now());
    var isPre = cfg.phase === 'pre' ? true : cfg.phase === 'live' ? false : ms > 0;

    var d = Math.floor(ms / 86400000), h = Math.floor(ms % 86400000 / 3600000),
        m = Math.floor(ms % 3600000 / 60000), s = Math.floor(ms % 60000 / 1000);
    var values = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
    all(section, '[data-nlp-cd]').forEach(function (el) {
      var v = values[el.getAttribute('data-nlp-cd')];
      if (el.textContent !== v) el.textContent = v;
    });

    function show(key, on) {
      all(section, '[data-nlp-show="' + key + '"]').forEach(function (el) { el.hidden = !on; });
    }
    show('isPre', isPre);
    show('showForm', isPre && !state.done);
    show('showDone', isPre && state.done);
    show('showLive', !isPre);

    var titles = cfg.titles;
    if (titles) {
      var text = !isPre ? titles.live
        : (d > 0 ? String(titles.pre || '').replace(/\[giorni\]/g, d) : titles.last_day);
      all(section, '[data-nlp-final-title]').forEach(function (el) {
        if (text && el.textContent !== text) el.textContent = text;
      });
    }
  }

  function renderDoneTitles() {
    all(document, '[data-nlp-done-title]').forEach(function (el) {
      var withName = el.getAttribute('data-title-name') || '';
      var noName = el.getAttribute('data-title-noname') || '';
      el.textContent = state.name && withName ? withName.replace(/\[nome\]/g, state.name) : noName;
    });
  }

  function tick() {
    all(document, '[data-nlp-section]').forEach(renderSection);
  }

  /* ---------------- Form -> Klaviyo ---------------- */
  function utm() {
    var out = {};
    try {
      var p = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        if (p.get(k)) out['bfcm_' + k] = p.get(k);
      });
    } catch (e) {}
    return out;
  }

  function subscribe(cfg, name, email) {
    var k = cfg.klaviyo || {};
    var props = {
      bfcm_language: cfg.language || '',
      bfcm_country: cfg.country || '',
      bfcm_source: k.source || ''
    };
    var extra = utm();
    for (var key in extra) props[key] = extra[key];

    // Revision 2025-01-15: l'endpoint accetta first_name, properties e il consenso
    // (subscriptions) nello stesso profilo, quindi basta una sola chiamata.
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.companyId || ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': k.revision || '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: k.source || undefined,
            profile: { data: { type: 'profile', attributes: {
              email: email,
              first_name: name,
              properties: props,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: k.listId } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
    });
  }

  function trackLead(cfg) {
    // Evento interno Shopify: lo ascolterà un Custom Pixel (Impostazioni > Eventi dei clienti)
    // per inviare "Lead" a Meta e "Contatto" a Google Ads. Nessuna chiamata diretta a fbq/gtag.
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('nlp_optin_lead', {
          list_id: (cfg.klaviyo || {}).listId,
          language: cfg.language,
          country: cfg.country
        });
      }
    } catch (e) {}
  }

  function formConfig(form) {
    if (!form.__nlpConfig) form.__nlpConfig = readJSON(form.querySelector('script[data-nlp-form-config]'));
    return form.__nlpConfig;
  }

  function onSubmit(e) {
    var form = e.target.closest ? e.target.closest('[data-nlp-form]') : null;
    if (!form) return;
    e.preventDefault();
    var cfg = formConfig(form);
    var msg = cfg.messages || {};
    var err = form.querySelector('[data-nlp-err]');
    var btn = form.querySelector('button[type="submit"]');
    function fail(text) { if (err) { err.textContent = text || ''; err.hidden = false; } }

    var name = ((form.querySelector('[name="first_name"]') || {}).value || '').trim();
    var email = ((form.querySelector('[name="email"]') || {}).value || '').trim();
    var consentEl = form.querySelector('[name="consent"]');
    if (name.length < 2) return fail(msg.name);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail(msg.email);
    if (!consentEl || !consentEl.checked) return fail(msg.consent);
    if (!cfg.klaviyo || !cfg.klaviyo.companyId || !cfg.klaviyo.listId) return fail(msg.network);

    if (btn) btn.disabled = true;
    subscribe(cfg, name, email).then(function () {
      state.done = true; state.name = name;
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ done: true, name: name })); } catch (e2) {}
      renderDoneTitles();
      trackLead(cfg);
      tick();
    }).catch(function () {
      fail(msg.network);
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  }

  function onInput(e) {
    var form = e.target.closest ? e.target.closest('[data-nlp-form]') : null;
    if (!form) return;
    var err = form.querySelector('[data-nlp-err]');
    if (err) err.hidden = true;
  }

  /* ---------------- Avvio e theme editor ---------------- */
  function refresh() {
    renderDoneTitles();
    tick();
  }

  window.NLPBF = { refresh: refresh };

  // Listener delegati: valgono anche per le sezioni ricaricate dal theme editor.
  document.addEventListener('submit', onSubmit);
  document.addEventListener('input', onInput);
  document.addEventListener('change', onInput);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function () { setTimeout(refresh, 0); });

  refresh();
  setInterval(tick, 1000);
})();
